import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useAppTheme } from "../theme/useAppTheme";
import { pageBackground } from "../theme/resolveThemeColors";

export default function AuthLayout() {
  const themeColors = useAppTheme();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: pageBackground(themeColors),
        color: themeColors.scaffoldText,
      }}
    >
      <ToastContainer position="top-center" autoClose={3000} />
      <Outlet />
    </div>
  );
}
